// 会员中心数据

const dataobj = {
    vipdate: [{
        date: "一个月",
        money: 28,
        money2: 28,
        money3: 28
    },
    {
        date: "三个月",
        money: 28,
        money2: 28,
        money3: 28
    },
    {
        date: "一年",
        money: 28,
        money2: 28,
        money3: 28
    }
    ],
    privilegelist: [{
        imgurl: "/static/images/vip_silu.png",
        title: "推荐思路不受限",
        content: "会员无限次提供推荐思路"
    },
    {
        imgurl: "/static/images/vip_chachong.png",
        title: "查重不受限",
        content: "会员查重不限次数篇数"
    },
    {
        imgurl: "/static/images/vip_first.png",
        title: "查重优先",
        content: "会员优先于普通用户"
    },
    {
        imgurl: "/static/images/vip_jiangchong.png",
        title: "专享智能降重",
        content: "会员专享对重复句子智能降重"
    },
    {
        imgurl: "/static/images/vip_autox.png",
        title: "专享智能纠错",
        content: "会员专享论文纠错功能"
    },
    {
        imgurl: "/static/images/vip_wenti.png",
        title: "问题优先处理",
        content: "优先售后和技术支持"
    },
    {
        imgurl: "/static/images/vip_new.png",
        title: "优先使用新功能",
        content: "新功能会员优先体验"
    },
    {
        imgurl: "/static/images/vip_vip.png",
        title: "会员VIP标识",
        content: "VIP标识亮起来"
    },
    {
        imgurl: "/static/images/vip_wenixian.png",
        title: "专属文献",
        content: "会员专享更多专属文献"
    }
    ],
    vip_pk: [
        [{
            content: "功能特权"
        },
        {
            content: "专业文献资料推荐、搜索"
        },
        {
            content: "智能生成提纲"
        },
        {
            content: "智能生成推荐思路"
        },
        {
            content: "实时查重"
        },
        {
            content: "智能降重"
        },
        {
            content: "智能纠错"
        },
        {
            content: "智能生成摘要"
        },
        {
            content: "智能生成致谢"
        },
        {
            content: "导入/导出word"
        },
        {
            content: "保存文章篇数"
        },
        {
            content: "保存笔记条数"
        }
        ],
        [{
            content: "会员"
        },
        {
            content: "无限"
        },
        {
            icon: "/static/images/vip_yellowgougou.png"
        },
        {
            icon: "/static/images/vip_yellowgougou.png"
        },
        {
            icon: "/static/images/vip_yellowgougou.png"
        },
        {
            content: "50次/每天"
        },
        {
            icon: "/static/images/vip_yellowgougou.png"
        },
        {
            icon: "/static/images/vip_yellowgougou.png"
        },
        {
            icon: "/static/images/vip_yellowgougou.png"
        },
        {
            icon: "/static/images/vip_yellowgougou.png"
        },
        {
            content: "无限"
        },
        {
            content: "无限"
        },
        {
            content: "低至18元每月",
            button: true
        }
        ],
        [{
            content: "免费方案"
        },
        {
            content: "无限"
        },
        {
            icon: "/static/images/vip_yellowgougou.png"
        },
        {
            icon: "/static/images/vip_redchacha.png",
            class: "cha"
        },
        {
            content: "2次/人"
        },
        {
            icon: "/static/images/vip_redchacha.png",
            class: "cha"
        },
        {
            icon: "/static/images/vip_redchacha.png",
            class: "cha"
        },
        {
            icon: "/static/images/vip_yellowgougou.png"
        },
        {
            icon: "/static/images/vip_yellowgougou.png"
        },
        {
            icon: "/static/images/vip_yellowgougou.png"
        },
        {
            content: "无限"
        },
        {
            content: "无限"
        }
        ]
    ]

}

export default dataobj




// WEBPACK FOOTER //
// ./src/pages/vip/data.js